import { Talent } from "../../Classes";

const tier6 = [
  null,
  null,
  new Talent(
    "Weapon Mastery",
    "ability_hunter_swiftstrike",
    ["Increases the damage you deal with all weapons by ", "%."],
    5,
    [[2, 4, 6, 8, 10]]
  ),
  null,
];

export default tier6;
